import { supabase } from "../supabase/supabase";

// Records a smack talk change in the league activity feed.
//
// move_history carries this alongside roster moves, freezes and 5x Plays
// (migration 042, extended by 051). The partial unique index
// (league_id, member_id, week, event_type, coalesce(team_added, ''))
// allows exactly one such row per manager per week, which is the behaviour
// wanted: someone editing their line four times in an afternoon should not
// push everyone else's moves off the feed.
//
// That index is partial and keyed on an expression, so PostgREST's upsert
// cannot target it. An insert is attempted and a unique violation is treated
// as "already announced this week", which is a no-op: the feed renders the
// manager's CURRENT smack talk rather than the copy stored here, so a repeat
// edit needs no write at all.
//
// Reading it live is what makes that safe. move_history has an INSERT policy
// but no UPDATE policy, so rewriting the row would silently affect zero rows
// and leave the feed showing the first wording of the week. It also means
// blocking keeps working for free: maskBlockedMember nulls smack_talk, so a
// blocked manager has no text to render.
//
// detail still carries the text as written at the time. Nothing displays it,
// but it is the only record of what was actually said in that week.
const UNIQUE_VIOLATION = "23505";

export async function recordSmackTalkEvent({ leagueId, memberId, week, text }) {
  if (!leagueId || !memberId || week == null || !text) return { ok: false, skipped: true };

  const { error } = await supabase.from("move_history").insert({
    league_id: leagueId,
    member_id: memberId,
    week,
    event_type: "smack_talk",
    detail: { text },
  });

  if (!error) return { ok: true };

  // Already announced this week. The feed shows the live text, so there is
  // nothing to bring up to date.
  if (error.code === UNIQUE_VIOLATION) return { ok: true, alreadyAnnounced: true };

  // Best effort. The smack talk itself is already saved, so a failure here
  // must not read to the manager as a failed save.
  console.error("Could not record smack talk in activity:", error);
  return { ok: false, error };
}
